var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7156 3.36566L2.24062 8.28753C2.09187 8.3282 1.95926 8.41374 1.86088 8.53249C1.76249 8.65125 1.7031 8.79745 1.6908 8.95117C1.67851 9.1049 1.7139 9.25867 1.79215 9.39156C1.87041 9.52445 1.98772 9.62998 2.12812 9.69378L10.1531 13.4907C10.3103 13.5635 10.4366 13.6897 10.5094 13.8469L14.3062 21.8719C14.3701 22.0123 14.4756 22.1296 14.6085 22.2079C14.7414 22.2861 14.8951 22.3215 15.0489 22.3092C15.2026 22.2969 15.3488 22.2375 15.4675 22.1392C15.5863 22.0408 15.6718 21.9082 15.7125 21.7594L20.6344 4.28441C20.6717 4.15689 20.674 4.02168 20.6411 3.89296C20.6081 3.76424 20.5412 3.64675 20.4472 3.5528C20.3533 3.45885 20.2358 3.39191 20.1071 3.35898C19.9784 3.32605 19.8431 3.32836 19.7156 3.36566V3.36566Z",
    stroke: "#68C6CA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3969 13.6031L14.6344 9.3656",
    stroke: "#68C6CA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSend);
export default __webpack_public_path__ + "static/media/footer_send.f88c73deaf660a6d6121b8e92c39c460.svg";
export { ForwardRef as ReactComponent };